import { useSyncExternalStore } from "react";
import { clearTextMetrics } from "./textMetrics";

const listeners = new Set<() => void>();
let fontRevision = 0;
let detachFonts: (() => void) | undefined;

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (!detachFonts && typeof document !== "undefined" && document.fonts) {
    const fonts = document.fonts;
    let active = true;
    const refresh = () => {
      if (!active) return;
      clearTextMetrics();
      fontRevision += 1;
      listeners.forEach((notify) => notify());
    };
    fonts.addEventListener("loadingdone", refresh);
    fonts.addEventListener("loadingerror", refresh);
    // Първият render може да е измерил fallback шрифта. Не пазим тази
    // ширина след зареждането на web fonts (включително от браузърния кеш).
    void fonts.ready.then(refresh);
    detachFonts = () => {
      active = false;
      fonts.removeEventListener("loadingdone", refresh);
      fonts.removeEventListener("loadingerror", refresh);
    };
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      detachFonts?.();
      detachFonts = undefined;
    }
  };
}

const getSnapshot = () => fontRevision;
const getServerSnapshot = () => 0;

/** Един FontFaceSet listener за всички маси, а не по един на маса. */
export function useSchemaFonts() {
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
